import {useSelector} from 'react-redux'
import {getIsBoVioEnvironment, getIsOTAMode} from 'modules/search/selectors'

export const useOtaMode = () => {
  const isOTAMode = useSelector(getIsOTAMode)
  const isBoVioEnvironment = useSelector(getIsBoVioEnvironment)

  return {
    isOTAMode,
    isBoVioEnvironment
  }
}
